var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickMyclass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.66667 2.33329C4.66667 3.25377 3.92048 3.99996 3 3.99996C2.07952 3.99996 1.33333 3.25377 1.33333 2.33329C1.33333 1.41282 2.07952 0.666626 3 0.666626C3.92048 0.666626 4.66667 1.41282 4.66667 2.33329ZM2.16667 12.3333V17.3333H0.5V7.33329C0.5 5.95258 1.61929 4.83329 3 4.83329C3.68383 4.83329 4.30352 5.10784 4.75488 5.55273L6.73358 7.42138L8.66092 5.49403L9.83942 6.67255L6.76675 9.74521L5.5 8.54888V17.3333H3.83333V12.3333H2.16667ZM6.33333 3.16663H13.8333V10.6666H6.33333V12.3333H9.97117L12.3241 17.3333H14.1661L11.8132 12.3333H14.6667C15.1269 12.3333 15.5 11.9602 15.5 11.5V2.33329C15.5 1.87306 15.1269 1.49996 14.6667 1.49996H6.33333V3.16663Z",
    fill: "#2F3444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickMyclass);
export default __webpack_public_path__ + "static/media/quick-myclass.bfba9e06e2b8dd9da169378047b5e79a.svg";
export { ForwardRef as ReactComponent };